import styled from "styled-components";

export const BackLinkStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  cursor: pointer;
  margin-bottom: 4px;
  width: fit-content;
`;

// The 420px cap fit the original slider-only control; the wrap now also
// holds the All/Applications view toggle, so it lays out as its own flex
// row and the row sizes to its content instead of wrapping the buttons.
export const SliderRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  .label { font-size: 12.5px; white-space: nowrap; }
  .slider-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
  }
`;
